import styled, {keyframes} from 'styled-components';
import {mediumMedia} from '../../../../../globalVariables/GlobalVariables';
import {dFlex, dInlineFlex, flexColumn, flexRow, alignCenter, justifyEnd, justifyBetween} from '../../../../../globalVariables/GlobalFlex';

const shieldPulse = keyframes`
    0%, 100% { transform: translateX(-50%) scale(1); }
    50% { transform: translateX(-50%) scale(1.12); }
`;

const shieldPulseStatic = keyframes`
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.12); }
`;

export const chip = styled.div`
    position: relative;
    width: 105px;
    min-height: 84px;
    ${dFlex}
    ${flexColumn}
    ${alignCenter}
    ${justifyEnd}
    gap: var(--space-xs);
    padding: var(--space-xs);
    border-radius: var(--radius-lg);
    cursor: pointer;
    background: var(--color-state-error-bg);
    ${mediumMedia}{
        order: 2;
        ${flexRow}
        width: auto;
        min-height: var(--dimension-9);
        ${alignCenter}
        ${justifyBetween}
        gap: var(--space-sm);
        margin-inline: var(--space-lg);
        padding: var(--space-xs);
    }
`;

export const status = styled.div`
    display: contents;
    ${mediumMedia}{
        ${dFlex}
        ${flexRow}
        ${alignCenter}
        gap: var(--space-sm);
    }
`;

export const illustration = styled.div<{ $icon?: string; }>`
    position: absolute;
    top: -30px;
    left: 50%;
    transform: translateX(-50%);
    width: 54px;
    height: 54px;
    background: url("${p => p.$icon}") center / contain no-repeat;
    animation: ${shieldPulse} 1.8s ease-in-out infinite;
    ${mediumMedia}{
        position: static;
        transform: none;
        width: 38px;
        height: 38px;
        animation: ${shieldPulseStatic} 1.8s ease-in-out infinite;
    }
`;

export const title = styled.div`
    text-align: center;
    line-height: 1.2;
    white-space: pre-line;
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-normal);
    color: var(--primitive-red-600);
    ${mediumMedia}{
        white-space: nowrap;
    }
`;

export const actionPill = styled.div`
    align-self: stretch;
    border-radius: var(--radius-full);
    background: var(--color-bg-base);
    & button:hover {
        border-color: transparent;
    }
    ${mediumMedia}{
        align-self: auto;
        flex: none;
    }
`;

export const verifiedChip = styled.div`
    ${dInlineFlex}
    ${alignCenter}
    gap: var(--space-sm);
    height: var(--dimension-6);
    padding-inline: var(--space-sm) var(--space-xl);
    border-radius: var(--radius-full);
    background: var(--color-bg-base);
`;

export const verifiedIcon = styled.div<{ $icon?: string; }>`
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    margin-inline-start: calc(-1 * var(--space-sm));
    background: url("${p => p.$icon}") center / contain no-repeat;
`;

export const verifiedText = styled.div`
    white-space: nowrap;
    font-size: var(--font-size-body-small);
    font-weight: var(--font-weight-semibold);
    color: var(--primitive-turquoise-600);
`;
